import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { getApiBase } from '../utils/apiBase';

const API = getApiBase();

/**
 * Read-only Legacy Book PDF export entitlement for an archive.
 * Default API response preserves current full export when enforcement is off.
 */
export function useExportEntitlements({ treeId = null, enabled = true } = {}) {
  const [entitlement, setEntitlement] = useState(null);
  const [loading, setLoading] = useState(Boolean(enabled && treeId));
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    if (!enabled || !treeId) return;
    setLoading(true);
    setError(null);
    try {
      const { data } = await axios.get(`${API}/trees/${treeId}/export-entitlements`);
      setEntitlement(data);
    } catch (err) {
      setError(err);
      setEntitlement(null);
    } finally {
      setLoading(false);
    }
  }, [enabled, treeId]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { entitlement, loading, error, refresh };
}
